import CollaborationCursor from '@tiptap/extension-collaboration-cursor';

export const collaborationCursorExtension = CollaborationCursor.configure({
  // provider,
  // user: {
  //   name: user?.name || 'Fellow User',
  //   color: awarenessColor,
  // },
  render({ name, color }) {
    const cursor = document.createElement('span');

    cursor.classList.add(
      'collaboration-cursor',
      `--${color}`,
      'collaboration-cursor__caret',
    );

    const label = document.createElement('div');

    label.classList.add('collaboration-cursor__label');

    label.insertBefore(document.createTextNode(name), null);
    cursor.insertBefore(label, null);

    return cursor;
  },
  selectionRender({ color }) {
    return {
      class: `collaboration-cursor collaboration-cursor__selection --${color}`,
    };
  },
});
